
const formReset = (form) => {
    form.classList.remove('loading');
    form.querySelector('.thom-form__error').classList.add('visuallyhidden');
    form.reset();
};

export { formReset };
